module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "content-inner-fix",
    attrs: {
      "id": "content"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "page-title-wrap new-sch"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "search-wrap"
  }, [_c('div', {
    staticClass: "input-group search"
  }, [_c('div', {
    staticClass: "input-group-inner"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchQuery),
      expression: "searchQuery"
    }],
    staticClass: "font-body-style3",
    attrs: {
      "type": "text",
      "placeholder": "검색어를 입력해주세요.",
      "title": "검색어 입력"
    },
    domProps: {
      "value": (_vm.searchQuery)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.handleSearch.apply(null, arguments)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchQuery = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn-search",
    attrs: {
      "type": "button",
      "aria-label": "검색 버튼",
      "title": "검색 버튼"
    },
    on: {
      "click": _vm.handleSearch
    }
  }, [_vm._m(2)])])])])]), _vm._v(" "), _c('div', {
    staticClass: "content-section new-pd-type"
  }, [_c('div', {
    staticClass: "job-posting-container global-search new-ver"
  }, [_c('SearchContent', {
    ref: "searchTabs",
    attrs: {
      "search-query": _vm.searchQuery,
      "search-results": _vm.searchResults,
      "is-loading": _vm.isLoading,
      "has-searched": _vm.hasSearched,
      "center-orgs-data": _vm.centerOrgsData
    },
    on: {
      "search": _vm.executeSearch,
      "tab-change": _vm.handleTabChange,
      "tag-search": _vm.handleTagSearch
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "search-keyword"
  }, [_c('PopularSearches', {
    key: (_vm.currentActiveOrg + "-" + _vm.currentActiveCenter),
    ref: "popularSearches",
    attrs: {
      "org-type": _vm.currentActiveOrg,
      "center-type": _vm.currentActiveCenter,
      "show-search-count": false,
      "show-refresh-button": false,
      "auto-refresh-interval": 300000
    },
    on: {
      "search-keyword": _vm.handlePopularSearchClick
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "search-box recent-search"
  }, [_c('h2', {
    staticClass: "search-box-title"
  }, [_vm._v("내 검색어")]), _vm._v(" "), _c('ul', {
    staticClass: "search-list"
  }, _vm._l((_vm.recentSearches), function(keyword, index) {
    return _c('li', {
      key: index
    }, [_c('a', {
      attrs: {
        "href": "#",
        "aria-label": "내 검색어 페이지로 이동",
        "title": "내 검색어 페이지로 이동"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.searchKeyword(keyword)
        }
      }
    }, [_vm._v("\n                  " + _vm._s(keyword) + "\n                ")])])
  }), 0)])], 1)], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "location"
  }, [_c('ol', [_c('li', [_c('a', {
    attrs: {
      "href": "#",
      "title": "홈"
    }
  }, [_c('i', {
    staticClass: "ico ico-home"
  }, [_c('span', {
    staticClass: "ir-text"
  }, [_vm._v("홈")])])])]), _vm._v(" "), _c('li', {
    staticClass: "font-body-style4"
  }, [_vm._v("\n          통합검색\n        ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-title"
  }, [_c('div', {
    staticClass: "h1-title"
  }, [_vm._v("통합검색")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('i', {
    staticClass: "ico ico-search"
  }, [_c('span', {
    staticClass: "ir-text"
  }, [_vm._v("검색")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ae020ba6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/main/search/UnifiedSearchPage.vue
// module id = 1500
// module chunks = 6